<!-- Die Reiter-Inhalte hängen an <ng-template matTabContent> und werden erst beim
     Öffnen des Reiters gebaut. Ohne das rendert Material alle Reiter sofort mit: mit den
     Lokalzeit-Grafiken sind das rund 1300 Karten und 13.000 Boxen auf einmal, was die
     Seite unbedienbar macht. Die eingetragenen Werte überleben den Wechsel, weil sie in
     image.values im Dokumentbaum stehen und nicht nur in der Komponente. -->
@if (wetterTerminalDocumentWrapper && wetterTerminalDocumentWrapper.data$ | async; as wetterTerminalDoc) {
  <div class="document-detail-container">
    <mat-tab-group mat-stretch-tabs="false"
      mat-align-tabs="start"
      class="document-detail-tab-group"
      animationDuration="500ms"
      [(selectedIndex)]="selectedTabIndex">

      @for (tab of wetterTerminalDoc?.tabs; track $index) {
        <ng-container [ngTemplateOutlet]="recursiveTabTmpl"
          [ngTemplateOutletContext]="{$implicit: tab}"
          class="document-detail-tab">

          <mat-tab [label]="tab!.caption">
            <!-- Das matTabContent-Template muss DIREKTES Kind von <mat-tab> sein: MatTab
                 sucht es mit @ContentChild(..., static: true), also bevor @if-Blöcke
                 überhaupt existieren. Läge es in einem @if, fände Material es nicht, würde
                 auf den Reiter-Rumpf zurückfallen – und der enthält dann nur noch eine
                 Template-Deklaration, der Reiter bliebe leer. -->
            <ng-template matTabContent>
            @if (tab.containerList && tab.containerList[0].containerType !== 'Tab') {
              <app-document-detail-elements [documentId]="documentId"
                [bereich]="tab!.caption"
                [tab]="tab">
              </app-document-detail-elements>
            } @else {
              <!-- Kein selectedTabIndex-Guard: der Index gilt fuer die ganze Tab-Gruppe, nicht fuer
                   diesen Reiter. Ein Guard "> 0" wuerde die Unter-Reiter des ERSTEN Reiters
                   (Index 0) dauerhaft ausblenden. -->
              <mat-tab-group animationDuration="500ms" mat-stretch-tabs="true" mat-align-tabs=""
                selectedIndex="0">
                @for (subTab of tab.containerList; track $index) {
                  <mat-tab [label]="subTab!.caption">
                    <ng-template matTabContent>
                    <!-- Dritte Ebene: die Lokalzeit-Städte tragen selbst wieder Reiter
                         (Heute, Nacht, ... , KI-Texte). Nur wenn deren Kinder Reiter sind,
                         sonst rendert der Zweig darunter die Elemente wie bisher. -->
                    @if (hatUnterreiter(subTab)) {
                      <mat-tab-group animationDuration="500ms" mat-stretch-tabs="false"
                        mat-align-tabs="start" selectedIndex="0">
                        @for (subSubTab of subTab.containerList; track $index) {
                          <mat-tab [label]="subSubTab!.caption">
                            <ng-template matTabContent>
                              <app-document-detail-elements [documentId]="documentId"
                                [bereich]="tab!.caption"
                                [tab]="layoutElementUtil.asTab(subSubTab)"
                                (copyEvent)="getLokalzeitenEvent($event, subTab, tab)">
                              </app-document-detail-elements>
                            </ng-template>
                          </mat-tab>
                        }
                      </mat-tab-group>
                    } @else {
                      <app-document-detail-elements [documentId]="documentId"
                        [bereich]="tab!.caption"
                        [tab]="layoutElementUtil.asTab(subTab)"
                        (copyEvent)="getLokalzeitenEvent($event, subTab, tab)">
                      </app-document-detail-elements>
                    }
                    </ng-template>
                  </mat-tab>
                }
              </mat-tab-group>
            }
            @if (tab.containerList && getIndexOfNonTabElement(tab) > 0 && tab.containerList[getIndexOfNonTabElement(tab)]) {
              <app-document-detail-elements [documentId]="documentId"
                [bereich]="tab!.caption"
                [tab]="tab">
              </app-document-detail-elements>
            }
            </ng-template>

          </mat-tab>

        </ng-container>
      }
    </mat-tab-group>

    <!-- Tabs. Mit dem recursiveTabTmpl werden rekursiv subtabs rausgerendert -->
    <ng-template #recursiveTabTmpl let-tab>
      @for (subTab of tab.containerList; track $index) {
        <ng-container
          [ngTemplateOutlet]="recursiveTabTmpl"
          [ngTemplateOutletContext]="{$implicit: subTab}">
        </ng-container>
      }
    </ng-template>
  </div>
} @else {
  <app-loading-error [loadingWrapper]="wetterTerminalDocumentWrapper"
    [message]="'Fehler beim Laden des Dokuments: ' + documentId"
    (onReload)="reload()">
  </app-loading-error>
}
